import { render, staticRenderFns } from "./SummaryAdditional.vue?vue&type=template&id=79d4308d"
import script from "./SummaryAdditional.vue?vue&type=script&lang=js"
export * from "./SummaryAdditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports